import React from "react";
import { GetBrandedSkillScaffoldIcon } from "../../../../services/BrandingService";

export default function ERSSCurrentIcon(){
  return <img
        className="in-progress-erss-logo"
        src={GetBrandedSkillScaffoldIcon()}
        alt="Amira Logo"
      />
}